import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Typography from '@mui/material/Typography';
import Logo from '../assets/img/logo_menu.png'
import Container from '@mui/material/Container';
import { Link } from '@mui/material';



function Copyright(props) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" href="https://www.clinicasangiorgio.it">
        Policlinico San Giorgio S.p.A.
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}
function Login() {
  const [UserName,setUserName] = useState('');
  const [Password,setPassword] = useState('');
  const [Message,setMessage] = useState('');
  const usenavigate = useNavigate();

  useEffect(() => {
    let username = localStorage.getItem("username");
    let jwtToken = localStorage.getItem("token");
    if (username === '' || username === null) {
      usenavigate('/login')
    }else{
      usenavigate('/admin/dashboard')
    }
    if (jwtToken === '' || jwtToken === null) {
      usenavigate('/login')
    }else{
      usenavigate('/admin/dashboard')
    }
  }, [])
  let handleSubmit = async (e) => {
    e.preventDefault();
    try {
      
      let res = await fetch("api/login/checkUser", {
        method: "POST",
        headers: {
            'Accept': 'application/json, text/plain',
            'Content-Type': 'application/json;charset=UTF-8',
            'xApiKey':'E%Je6Q0]EFwu,kJW-$ttR4qWvRf=svI@'        
          },
        body: JSON.stringify({
          UserName: UserName,
          Password: Password
        })
      });
      let resJson = await res.json();
      if (res.status === 200) {
        localStorage.setItem('username', UserName);
        localStorage.setItem('token', resJson);
        setUserName("");
        setPassword("");
        setMessage("Login avvenuto con successo");
        usenavigate('/admin/dashboard')
      } else {
        setMessage("Some error occured");
      }
    } catch (err) {
      console.error(err);
    }
  };
  return (
    <Container component="main" maxWidth="xs">
<Box
              sx={{
                marginTop: 8,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
            <img src={Logo} alt="Logo" style={{width:100,marginBottom:30}}/>
          <Typography component="h1" variant="h5">
            Accesso Area Riservata
          </Typography>
          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="username"
              label="Username"
              name="username"
              autoComplete="username"
              autoFocus
              value={UserName}
              onChange={(e) => setUserName(e.target.value)}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
              value={Password}
              onChange={(e) => setPassword(e.target.value)}
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              onClick={handleSubmit}
            >
              Login
            </Button>
            <Button href="/" > <ArrowBackIcon/> Ritorna al questionario</Button>
            </Box>

      </Box>
      <Copyright sx={{ mt: 8, mb: 4 }} />
    </Container>
    
  )
}

export default Login